/**
 * @Author: Zewei
 * @Date:   2018-01-31T13:49:26+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-24T16:44:41+08:00
 */

 import React from 'react';
 import { Modal, Row, Col, Input, Form, Select, Button, Radio, AutoComplete } from 'antd';

 const Option = Select.Option;
 const FormItem = Form.Item;
 const RadioGroup = Radio.Group;

 const DepartmentAddModal = Form.create()(
   (props) => {
     const { form, visible, title, departmentDetail, isFirstInputDisabled, employeeList,
             handleCancel, handleUpdate, handleSearch } = props;
     const { getFieldDecorator, isFieldsTouched } = form;
     // const fixedSelectStyle = {width: 172};

     const children = employeeList.map((item) => {
         return <Option key={item.id}>{ item.real_name }</Option>;
     });

     let isDisabled = !isFieldsTouched();


     return (
       <Modal
         title={title}
         visible={visible}
         onCancel={handleCancel}
         width={1100}
         destroyOnClose={true}
         footer={[
                 <Button key="returnBtn" type="primary" onClick={handleCancel}>返回</Button>,
                 <Button key="editBtn" type="primary" onClick={handleUpdate} disabled={isDisabled}>编辑</Button>
             ]}
       >
         <Form layout="inline">
             <Row>
                 <Col span={6}>
                     <FormItem label="部门名称">
                         {getFieldDecorator('name', {
                             initialValue: departmentDetail.name
                         })(<Input disabled={isFirstInputDisabled} />)}
                     </FormItem>
                 </Col>
                 <Col span={6}>
                     <FormItem label="编制人数">
                         {getFieldDecorator('authorized_strength', {
                             initialValue: departmentDetail.authorized_strength
                         })(<Input type="number" />)}
                     </FormItem>
                 </Col>
                 <Col span={6}>
                     <FormItem label="部门主管">
                         {getFieldDecorator('charge_user_id', {
                             initialValue: departmentDetail.charge_user_id
                         })(
                             // <Select style={fixedSelectStyle}>
                             //     {
                             //         users ?
                             //         users.map((item) => {
                             //             return <Option key={item.id} value={item.id}>{ item.user_name }</Option>
                             //         })
                             //         :
                             //         ''
                             //     }
                             // </Select>
                             <AutoComplete
                                 onSearch={handleSearch}
                             >
                                 { children }
                             </AutoComplete>
                         )}
                     </FormItem>
                 </Col>
                 <Col span={3}>
                     <FormItem label="人事部">
                         {getFieldDecorator('is_hr', {
                             initialValue: departmentDetail.is_hr
                         })(
                             <RadioGroup>
                               <Radio value={true}></Radio>
                             </RadioGroup>
                         )}
                         </FormItem>
                 </Col>
                 <Col span={3}>
                     <FormItem label="行销部">
                         {getFieldDecorator('is_xingxiao', {
                             initialValue: departmentDetail.is_xingxiao
                         })(
                             <RadioGroup>
                               <Radio value={true}></Radio>
                             </RadioGroup>
                         )}
                     </FormItem>
                 </Col>
             </Row>
         </Form>
       </Modal>
     );
   }
 );

 export default DepartmentAddModal;



// WEBPACK FOOTER //
// ./src/components/DepartmentStructure/DepartmentEditModal.js